import { Component, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { InfoOption } from '../../components/info/info.component';
import { CommandEnum } from '../../definition/interface/enum';
import { infoOption } from '../../services/ref';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'support-form',
    templateUrl: './support-form.component.html',
    styleUrls: ['./support-form.component.scss'],
    standalone: false
})
export class SupportFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = infoOption;
  error: ValidationErrors = null;
  avDistribution: string;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.avDistribution =
      this.subscriptionFacade.getPledge()?.products[0]?.parameters
        ?.avDistribution || 'FREE';

    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.selectErrorInputAndScroll(this);

    this.extract()?.forEach(({ parameters }) => {
      if (
        !parameters.supportRepartition ||
        !parameters.supportRepartition.length
      ) {
        this.supportRepartition.setErrors({
          incorrect: true,
          message: 'Veuillez renseigner au moins un support',
        });
      }
    });
    this.error = this.supportRepartition.errors;

    if (this.error?.maxlength) {
      this.error = {
        ...this.error,
        message:
          "En mode piloté, vous ne pouvez sélectionner qu'un seul support de gestion sous mandat.",
      };
    }

    if (this.form.valid) {
      // PRE-4896 : préremplit les 4 champs "*Autocomplete" de la nouvelle slide "Taux par support",
      // pour tous les supports sélectionnés ici, quelle que soit l'organisation.
      this.subscriptionFacade.setCommand([CommandEnum.COMPLETE_SUPPORT_RATES]);
      this.subscriptionFacade.submitPledge(this);
    }
  }

  override extract() {
    const result = super.extract();
    if (this.avDistribution === 'PILOTED') {
      return result?.map(product => ({
        ...product,
        parameters: {
          ...product.parameters,
          supportRepartition: product.parameters.supportRepartition?.map(s => ({
            ...s,
            initalRepartition: 1,
            monthlyRepartition: 1,
          })),
        },
      }));
    }
    return result;
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
